/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { sendSlackNotification } from 'utils/errorReporter';
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const AIChatAPI = {
  sendMessageToStream: async(body: any) =>
    (await initAxios())
      ?.post('/aichatstream', JSON.stringify(body))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'AI Chat',
          JSON.stringify(err),
          'Failed to call /aichatstream on sendMessageToStream',
        );
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  sendMessage: async(body: any) =>
    (await initAxios())
      ?.post('/aichat', JSON.stringify(body))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'AI Chat',
          JSON.stringify(err),
          'Failed to call /aichat on sendMessage',
        );
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  uploadFile: async(file: any) =>
    (await initAxios())
      ?.post('/aichat/files/upload', file)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getFiles: async() =>
    (await initAxios())
      ?.get('/aichat/files')
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  deleteFile: async(file_id: any) =>
    (await initAxios())
      ?.get(`/aichat/files/delete/${file_id}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default AIChatAPI;
